module.exports = __webpack_public_path__ + "img/logo1.ae9e69b6.png";